import { render, staticRenderFns } from "./properties-website-navigation.vue?vue&type=template&id=87a71bbe&scoped=true"
import script from "./properties-website-navigation.vue?vue&type=script&lang=js"
export * from "./properties-website-navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a71bbe",
  null
  
)

export default component.exports